<template>
    <v-container fluid style="height: 90%; max-width: 97%">
        <v-row align="center">
            <v-col class="grow">
                <div :class="$vuetify.breakpoint.smAndDown ? 'text-h5' : 'display-2'">
                    <v-icon v-if="icon" class="mr-2" x-large :color="color">
                        {{ icon }}
                    </v-icon>
                    <span style="display: inline-block; vertical-align: middle">
                        {{ pageTitle }}
                    </span>
                </div>
            </v-col>

            <v-col v-if="$slots.actions" class="shrink">
                <slot name="actions" />
            </v-col>
        </v-row>

        <slot />
    </v-container>
</template>

<script>
export default {
    props: {
        pageTitle: String,
        icon: String,
        color: String,
    },
};
</script>
